<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_modify_credit_information'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body-small">
                    <div class="credit-card-box">
                        <creditcardinput ref="creditCardInput" :gmoSeverScriptPath="appData.gmoSeverScriptPath" :gmoShopId="appData.gmoShopId" currencyYen="true"
                            @on-change-input="handleChangeInput" @saveComplete="saveCardComplete">
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" @click="saveCreditCardInfo" :disabled="this.disableButton" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';
import CreditCardInput from './CreditCardInput.vue';

export default {
    data () {
        return {
            disableButton: true,
        };
    },
    methods: {
        handleChangeInput(cardNumber , cardSecurityCode , cardExpire , cardHolderName , validation) {
            if (validation) {
                this.disableButton = false;
            } else {
                this.disableButton = true;
            }
        },
        saveCreditCardInfo() {
            // save credit card information.
            this.$refs.creditCardInput.saveCreditCardInfo();
        },
        saveCardComplete() {
            this.$emit('save');
        }
    },
    created: function() {
    },
    mounted: function() {
    },
    watch: {
    },
    components: {
        creditcardinput: CreditCardInput
    },
    props: [ 'appData' , 'tenant' , 'creditCard' ]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.credit-card-box {
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: #f6f6f6;
}
</style>
